import React from 'react';
import Tooltip from 'components/Tooltip';
import { getTimezoneContext } from 'utils';

import './EventTimeHeader.scss';

const EventTimeHeader = ({ event, referenceDate, className }) => {
	const { eventAbbreviation, localAbbreviation, matchesLocalTime } = getTimezoneContext(
		event,
		referenceDate
	);
	const tooltip = matchesLocalTime
		? `Event timezone (${eventAbbreviation})`
		: `Event timezone (${eventAbbreviation}), not your computer's local time (${localAbbreviation})`;

	return (
		<span className={`EventTimeHeader ${className || ''}`}>
			Time ({eventAbbreviation})
			<Tooltip content={tooltip} />
		</span>
	);
};

export default EventTimeHeader;
